<!-- ONDEMANDS HOME PAGE -->
<div class="ondemands_home" *ngIf="ondemands_home">

    <!-- SLIDER -->
    <app-slider [breakpoints]="{'0.00': {slidesPerView: 1, spaceBetween: 10}, '@0.75': {slidesPerView: 2, slidesPerGroup:2, spaceBetween: 10}, '@1.00': { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 10 }, '@1.25': { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 10 }, '@1.50': { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 10 }}" 
        [sliderLength]="ondemands_home.video.length" (onChangeIndex)="onSlideChange($event)" (onChangeSlides)="sliderSlides = $event">

        <swiper-slide lazy="true" *ngFor="let ondemand of ondemands_home.video; let i = index" class="h-auto" [ngStyle]="{'z-index': (ondemands_home.video.length - i)}">
            <app-video-thumbnail (click)="onOndemand(ondemand.id)" [ondemand]="ondemand" *ngIf="i <= sliderIndex"></app-video-thumbnail>
        </swiper-slide>

    </app-slider>
    <!-- SLIDER -->

</div>
<!-- ONDEMANDS HOME PAGE -->

<!-- ONDEMANDS -->
<div class="ondemands" *ngIf="ondemands.length > 0">

    <!-- SLIDER -->
    <app-slider [breakpoints]="{'0.00': {slidesPerView: 1, spaceBetween: 10}, '@0.75': {slidesPerView: 2, slidesPerGroup:2, spaceBetween: 10}, '@1.00': { slidesPerView: 3, slidesPerGroup:3, spaceBetween: 10 }, '@1.25': { slidesPerView: 4, slidesPerGroup:4, spaceBetween: 10 }, '@1.50': { slidesPerView: 4, slidesPerGroup:4, spaceBetween: 10 }}" 
        [sliderLength]="ondemands.length" (onChangeIndex)="onSlideChange($event)" (onChangeSlides)="sliderSlides = $event">
        <swiper-slide lazy="false" *ngFor="let ondemand of ondemands; let i = index" class="h-auto" [ngStyle]="{'z-index': (ondemands.length - i)}">
            <app-video-thumbnail (click)="onOndemand(ondemand.id)" [ondemand]="ondemand" *ngIf="i <= sliderIndex"></app-video-thumbnail>
        </swiper-slide>
    </app-slider>
    <!-- SLIDER -->

</div>
<!-- ONDEMANDS -->